/**
 * OneTrust cookie consent toast initialization.
 *
 * This is the webpack entry point that auto-initializes the consent toast
 * when the DOM is ready. It shows a success notification to California users
 * when they opt out of cookies (CCPA required).
 */
import { initOneTrustConsentListener } from './oneTrustConsentListener';
import { getOrCreateOptOutToastInstance } from './oneTrustOptOutToast';
export const initOneTrustCookieConsentToast = () => {
    initOneTrustConsentListener({
        onOptOut() {
            const optOutToast = getOrCreateOptOutToastInstance();
            optOutToast === null || optOutToast === void 0 ? void 0 : optOutToast.show();
        },
    });
};
initOneTrustCookieConsentToast();
